import React from 'react';
import { NewSchoolyear } from 'containers/MesAnneesScolaires/New';
import SchoolSettingsWrapper from 'containers/MesAnneesScolaires/School/SchoolSettingsWrapperLoadable';
import { Navigate, Outlet } from 'react-router-dom';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { PageTrackerWrapper } from 'queries/user/track';
import SchoolMainConfig from 'containers/MesAnneesScolaires/School/SchoolMainConfig/Loadable';
import Contacts from 'containers/MesAnneesScolaires/School/Contacts/Loadable';
import Passwords from 'containers/MesAnneesScolaires/School/Passwords/Loadable';
import ShareSchoolComponent from 'containers/MesAnneesScolaires/School/Share/Loadable';
import TagsRoot from 'containers/MesAnneesScolaires/School/Tags/Loadable';
import EditAnneeScolaire from './Schoolyear/General/Loadable';
import Holidays from './Schoolyear/Holidays/Loadable';
import SchoolyearSettingsWrapper from 'containers/MesAnneesScolaires/Schoolyear/SchoolyearSettingsWrapperLoadable';
import ClassroomOrgComponent from './School/ClassroomOrg/Loadable';
import AddressComponent from './School/Address/Loadable';
import NewSchool from './School/New/Loadable';
import { RedirectToSchoolyearSettingsOrMobileMenu } from 'containers/MesAnneesScolaires/RedirectToSchoolyearSettingsOrMobileMenu';
import ListSchoolyears from 'containers/MesAnneesScolaires/List/Loadable';
import SchoolyearSettings from 'containers/MesAnneesScolaires/Schoolyear/Settings/Loadable';
import { HeaderComponent } from 'containers/Header';
import { RedirectToSchoolSettingsOrMenu } from 'containers/MesAnneesScolaires/School/RedirectToSchoolSettingsOrMenu';
import { routes } from 'containers/routes';
import { SchoolyearDataProvider } from 'containers/MesAnneesScolaires/SchoolyearDataProvider';
import { SchoolDataProvider } from 'containers/MesAnneesScolaires/School/SchoolDataProvider';

export const MesAnneesScolairesRoutes = {
  path: 'mes-annees-scolaires',
  element: (
    <>
      <HeaderComponent noMobile withSubHeader />
      <Outlet />
    </>
  ),
  children: [
    {
      index: true,
      element: <ListSchoolyears />,
    },
    {
      path: 'new',
      element: <NewSchoolyear />,
    },
    {
      path: ':schoolyearId',
      element: <SchoolyearDataProvider />,
      children: [
        {
          index: true,
          element: <RedirectToSchoolyearSettingsOrMobileMenu />,
        },
        {
          path: 'ecoles/new',
          element: <NewSchool />,
        },
        {
          path: 'ecoles/:schoolId?',
          element: <SchoolDataProvider />,
          children: [
            {
              index: true,
              element: <RedirectToSchoolSettingsOrMenu />,
            },
            {
              path: '*',
              element: <SchoolSettingsWrapper />,
              children: [
                {
                  path: 'general',
                  element: (
                    <PageTrackerWrapper title="Années scolaires - configuration école - générale">
                      <SchoolMainConfig />
                    </PageTrackerWrapper>
                  ),
                },
                {
                  path: 'contacts',
                  element: (
                    <PageTrackerWrapper title="Années scolaires - configuration école - contacts">
                      <Contacts />
                    </PageTrackerWrapper>
                  ),
                },

                {
                  path: 'coordonnees',
                  element: (
                    <PageTrackerWrapper title="Années scolaires - configuration école - coordonnées">
                      <AddressComponent />
                    </PageTrackerWrapper>
                  ),
                },
                {
                  path: 'codes',
                  element: (
                    <TwoColumnsCardSidebar.Container>
                      <TwoColumnsCardSidebar.Section
                        titleKey="schoolyearSettings:schoolPasswords.title"
                        subtitleKey="schoolyearSettings:schoolPasswords.subtitle"
                      >
                        <PageTrackerWrapper title="Années scolaires - configuration école - mots de passe">
                          <Passwords />
                        </PageTrackerWrapper>
                      </TwoColumnsCardSidebar.Section>
                    </TwoColumnsCardSidebar.Container>
                  ),
                },
                {
                  path: 'share',
                  element: (
                    <PageTrackerWrapper title="Années scolaires - configuration école - partage">
                      <ShareSchoolComponent />
                    </PageTrackerWrapper>
                  ),
                },
                {
                  path: 'tags',
                  element: (
                    <PageTrackerWrapper title="Années scolaires - configuration école - étiquettes">
                      <TagsRoot />
                    </PageTrackerWrapper>
                  ),
                },
                {
                  path: 'org',
                  element: (
                    <PageTrackerWrapper title="Années scolaires - configuration école - multi-niveaux">
                      <ClassroomOrgComponent />
                    </PageTrackerWrapper>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: '*',
          element: <SchoolyearSettingsWrapper />,
          children: [
            {
              path: 'general',
              element: (
                <TwoColumnsCardSidebar.Container>
                  <EditAnneeScolaire />
                </TwoColumnsCardSidebar.Container>
              ),
            },
            {
              path: 'holidays',
              element: (
                <TwoColumnsCardSidebar.Main i18nKey="schoolyearSettings:setUpHolidaysAndPeriods">
                  <Holidays />
                </TwoColumnsCardSidebar.Main>
              ),
            },
            {
              path: 'settings',
              element: (
                <TwoColumnsCardSidebar.Main i18nKey="schoolyearSettings:deleteSchoolyear">
                  <SchoolyearSettings />
                </TwoColumnsCardSidebar.Main>
              ),
            },
            {
              path: '*',
              element: <Navigate to={routes.schoolyearsSettings} />,
            },
          ],
        },
      ],
    },

    {
      path: '*',
      element: <Navigate to={routes.schoolyearsSettings} />,
    },
  ],
};
